<template>
 <form @submit.prevent="sendDocuments()">
    <modal :close="closeModal" class="modal-wide">
      <h3 slot="header">Please, fill those informations to be able to collect funds from your projects</h3>
      <div slot="body">
        <!-- Legal Representative -->
        <h4>Legal Representative data</h4>
        <div class="row">
          <div class="col-lg-12">
            <form-error :errors='errors' :attribute="'birthday'">
              <datepicker v-model="formData.legalRepresentativeBirthday"
                :use-utc="true" format="yyyy-MM-dd"
                :typeable="false"
                :language="datapickerLang" class="mb-20"
                input-class="form-control"
                :placeholder="$t('profile.edit.birthday')"
                required>
              </datepicker>
            </form-error>
          </div>
          <div class="col-12 col-lg-6">
            <form-error :errors='errors' :attribute="'countryOfResidence'">
              <select v-if="countries.length" v-model="formData.legalRepresentativeCountryOfResidence" class="form-control mb-20" required>
                <option disabled value="">{{ $t('countryOfResidence') }}</option>
                <option v-for="(country, index) in countries" :value="country.iso_code" :key="index">
                  {{ country.name }}
                </option>
              </select>
            </form-error>
          </div>
          <div class="col-12 col-lg-6">
            <form-error :errors='errors' :attribute="'nationality'">
              <select v-if="countries.length" v-model="formData.legalRepresentativeNationality" class="form-control mb-20" required>
                <option disabled value="">{{ $t('nationality') }}</option>
                <option v-for="(country, index) in countries" :value="country.iso_code" :key="index">{{ country.name }}</option>
              </select>
            </form-error>
          </div>
          <h4 class="col-md-12">Legal Representative address</h4>
          <form-error :errors='errors' :attribute="'address'" class="col-md-6">
            <input v-model="formData.legalRepresentativeAddress.addressLine1" class="form-control" :placeholder="$t('profile.edit.streetName')" required>
          </form-error>
          <form-error :errors='errors' :attribute="'address'" class="col-md-3">
            <input v-model="formData.legalRepresentativeAddress.addressLine2" class="form-control" :placeholder="$t('profile.edit.streetNumber')" required>
          </form-error>
          <div class="col-md-3">
            <form-error :errors='errors' :attribute="'postcode'">
              <input v-model="formData.legalRepresentativeAddress.postalCode" class="form-control" :placeholder="$t('organization.zipCode')" required>
            </form-error>
          </div>
          <div class="col-md-6">
            <form-error :errors='errors' :attribute="'city'">
              <input v-model="formData.legalRepresentativeAddress.city" class="form-control" :placeholder="$t('organization.city')" required>
            </form-error>
          </div>
          <div class="col-md-6">
            <form-error :errors='errors' :attribute="'legalRepresentativeAddress.country'">
              <select v-if="countries.length" v-model="formData.legalRepresentativeAddress.country" class="form-control mb-20" required>
                <option disabled value="">{{ $t('country') }}</option>
                <option v-for="(country, index) in countries" :value="country.iso_code" :key="index">{{ country.name }}</option>
              </select>
            </form-error>
          </div>
        </div>
        <!-- Legal Organization -->
        <h4>Organization data</h4>
        <form-error :errors='errors' :attribute="'name'">
          <input v-model="formData.name" class="form-control" :placeholder="'Company name'" required>
        </form-error>
        <form-error :errors='errors' :attribute="'email'">
          <input v-model="formData.email" class="form-control" :placeholder="'Company email'" required>
        </form-error>
        <form-error :errors='errors' :attribute="'companyNumber'">
          <input v-model="formData.companyNumber" class="form-control" :placeholder="'Company Number'" required>
        </form-error>
        <div class="row">
          <form-error :errors='errors' :attribute="'addressLine1'" class="col-md-6">
            <input v-model="formData.headquartersAddress.addressLine1" class="form-control" :placeholder="$t('organization.streetName')" required>
          </form-error>
          <form-error :errors='errors' :attribute="'addressLine2'" class="col-md-3">
            <input v-model="formData.headquartersAddress.addressLine2" class="form-control" :placeholder="$t('organization.streetNumber')" required>
          </form-error>
          <div class="col-md-3">
            <form-error :errors='errors' :attribute="'postalCode'">
              <input v-model="formData.headquartersAddress.postalCode" class="form-control" :placeholder="$t('organization.zipCode')" required>
            </form-error>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <form-error :errors='errors' :attribute="'city'">
              <input v-model="formData.headquartersAddress.city" class="form-control" :placeholder="$t('organization.city')" required>
            </form-error>
          </div>
        <div class="col-md-6">
          <form-error :errors='errors' :attribute="'headquartersAddress.country'">
            <select v-if="countries.length" v-model="formData.headquartersAddress.country" class="form-control mb-20" required>
              <option disabled value="">{{ $t('country') }}</option>
              <option v-for="(country, index) in countries" :value="country.iso_code" :key="index">{{ country.name }}</option>
            </select>
          </form-error>
        </div>
      </div>
      <alert :error="error"></alert>
    </div>
    <button type="submit" slot="footer" class="btn btn-primary" style="width: 100px; margin: 5px">
      {{ $t("send") }}
    </button>
  </modal>
</form>

</template>

<script>
import organizationApi from '@/api/v1/organizations';
import dictionariesApi from '@/api/v1/shared/dictionaries';
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import Modal from '@/components/Modal';
import Datepicker from 'vuejs-datepicker';
import { pl, en } from 'vuejs-datepicker/src/locale';
// Mixins
import alert from '@/mixins/alert';

function uncapitalizeObjectProps(data) {
  const result = {};
  Object.keys(data).forEach((key) => {
    const prop = key.charAt(0).toLowerCase() + key.slice(1);
    result[prop] = data[key];
    if (result[prop] instanceof Object) result[prop] = uncapitalizeObjectProps(result[prop]);
  });
  return result;
}

export default {
  components: { Alert, FormError, Modal, Datepicker },
  mixins: [alert],
  props: ['user', 'organization'],
  data() {
    return {
      countries: [],
      locale: localStorage.getItem('lang'),
      formData: {
        name: '',
        email: '',
        companyNumber: '',
        headquartersAddress: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          postalCode: '',
          country: '',
        },
        legalPersonType: '',
        legalRepresentativeBirthday: '',
        legalRepresentativeCountryOfResidence: '',
        legalRepresentativeNationality: '',
        legalRepresentativeEmail: '',
        legalRepresentativeFirstName: '',
        legalRepresentativeLastName: '',
        legalRepresentativeAddress: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          postalCode: '',
          country: '',
        },
      },
      error: '',
    };
  },
  computed: {
    datapickerLang() {
      return this.locale === 'en' ? en : pl;
    },
    hasMangopayAccount() {
      return !!this.organization.mangopay_id;
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeFormModal');
    },
    sendDocuments() {
      this.formData.legalPersonType = 'ORGANIZATION';
      this.formData.legalRepresentativeBirthday =
        new Date(this.formData.legalRepresentativeBirthday).getTime() / 1000; // convert to seconds
      if (this.hasMangopayAccount) {
        organizationApi.updateMangopayOrganization(this.formData).then(() => {
          this.$emit('openDocumentsForm');
        }).catch(() => {
          this.error = 'Sorry, something went wrong. Please contact the administrator';
        });
      } else {
        organizationApi.createMangopayOrganization(this.formData).then(() => {
          this.$emit('openDocumentsForm');
        }).catch(() => {
          this.error = 'Sorry, something went wrong. Please contact the administrator';
        });
      }
    },
    setFormData() {
      if (this.hasMangopayAccount) {
        organizationApi.checkLegalUser().then((response) => {
          const data = response.data.user;
          data.LegalRepresentativeBirthday *= 1000; // convert to ms
          this.formData = uncapitalizeObjectProps(data);
        });
      } else {
        this.fillFormWithUserData();
      }
    },
    getCountryCodeById(countryId) {
      return this.countries.find(country => country.id === countryId).iso_code;
    },
    fillFormWithUserData() {
      this.formData.headquartersAddress.addressLine1 = this.organization.address_line_1;
      this.formData.headquartersAddress.addressLine2 = this.organization.address_line_2;
      this.formData.headquartersAddress.city = this.organization.city;
      this.formData.headquartersAddress.postalCode = this.organization.postcode;
      this.formData.headquartersAddress.country = this.getCountryCodeById(this.organization.country_id);
      this.formData.name = this.organization.name;
      this.formData.legalPersonType = this.organization.legal_person_type;
      this.formData.legalRepresentativeAddress.addressLine1 = this.user.address_line_1;
      this.formData.legalRepresentativeAddress.addressLine2 = this.user.address_line_2;
      this.formData.legalRepresentativeAddress.city = this.user.city;
      this.formData.legalRepresentativeAddress.postalCode = this.user.zip_code;
      this.formData.legalRepresentativeAddress.country = this.getCountryCodeById(this.user.country_id);
      this.formData.legalRepresentativeBirthday = this.user.birthday;
      this.formData.legalRepresentativeCountryOfResidence = this.getCountryCodeById(this.user.country_id);
      this.formData.legalRepresentativeNationality = this.getCountryCodeById(this.user.country_id);
      this.formData.legalRepresentativeEmail = this.user.email;
      this.formData.legalRepresentativeFirstName = this.user.full_name;
      this.formData.legalRepresentativeLastName = this.user.full_name;
      this.formData.email = this.user.email;
      this.formData.companyNumber = this.organization.nip;
    },
  },
  created() {
    dictionariesApi.getCountries((countries) => {
      this.countries = countries;
      this.setFormData();
    });
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?14842348